import { IFinanceQuote, IPlainBaseFinanceQuote, IPlainFinanceQuote } from '../model/IFinanceQuote';
import { ITransformer } from '../model/ITransformer';

const financeQuoteTransformer: Partial<ITransformer<IPlainFinanceQuote | IPlainBaseFinanceQuote, IFinanceQuote>> = {
  from(data: IPlainFinanceQuote | IPlainBaseFinanceQuote): IFinanceQuote {
    const quote: IFinanceQuote = {} as any;

    quote.token = data.token;
    quote.packageCode = data.packageCode;
    quote.isCashProduct = data.financeProductKey === 'CASH';
    quote.isPersonalized = data.isPersonalized;
    quote.monthlyPayment = data.monthlyPayment ?? 0;
    quote.totalAmountFinanced = data.totalAmountFinanced ?? 0;
    quote.comparisonRate = data.comparisonRate;
    quote.interestRate = data.interestRate;
    quote.deposit = data.deposit;
    quote.duration = data.duration;
    quote.exceptionReason = data.exceptionReason;
    quote.tooltips = data.legalTexts?.[0]?.tooltips?.['package-description'];
    quote.currency = { code: data.currency };
    if ('secondaryCurrencyQuote' in data && data.secondaryCurrencyQuote) {
      quote.secondaryCurrencyQuote = this.from(data.secondaryCurrencyQuote);
    }
    const disclaimers: string[] = [];
    const financeTermDisclaimer = data.legalTexts?.[0]?.disclaimerTexts?.[0]?.displayValue;
    if (!quote.isCashProduct && financeTermDisclaimer) {
      disclaimers.push(String(financeTermDisclaimer).replace('&#xb9;', ''));
    }
    quote.disclaimers = disclaimers;

    return quote;
  },
};

export default financeQuoteTransformer;
